const baseHistoryState = (history.state || {}).key;

/**
 * Go back in history or to home page if no history exists
 * @param {} router - Vue Router instance
 * @param {} [defaultRoute] - optional Vue router replace options 
 * @returns 
 */
export function goBack(router, defaultRoute = { name: 'home' }) {
  const currentHistoryState = (history.state || {}).key;
  if (currentHistoryState !== baseHistoryState) {
    router.go(-1);
    return;
  }
  router.push(defaultRoute);
}